var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SeparationLineAnchor',{attrs:{"id":_vm.anchorName,"show-separation-line":_vm.showSeparationLine,"anchor-text":_vm.anchorText,"headline":_vm.headline}})
}
var staticRenderFns = []

export { render, staticRenderFns }